<template>
  <div class="index">
    <Headers></Headers>
    <div class="banner">
      <swiper class="gallery-top"
              :options="swiperOptions"
              ref="mySwiper">
        <swiper-slide v-for="(item, index) in bannerlist"
                      :key="index"
                      :style="'background-image: url(' + item.banner_img + ');'">
          <!-- <img :src="item.banner_img" alt="" /> -->
        </swiper-slide>
        <div class="swiper-pagination"
             id="pagination"
             slot="pagination"></div>
      </swiper>
      <div class="infobox">
        <p class="p1">细胞STR鉴定综合供应商</p>
        <h2>给细胞一个基因ID，让行业放心使用</h2>
        <p class="p2">--华科鉴联基因科技（北京）有限公司</p>
      </div>
    </div>
    <Services></Services>
    <Database></Database>
    <About></About>
    <div class="container warp">
      <el-row :gutter="10">
        <el-col :xs="24"
                :sm="7"
                :md="7"
                :lg="7">
          <News></News>
        </el-col>
        <el-col :xs="24"
                :sm="7"
                :md="7"
                :lg="7">
          <Literature></Literature>
        </el-col>
        <el-col :xs="24"
                :sm="10"
                :md="10"
                :lg="10">
          <Training></Training>
        </el-col>
      </el-row>
    </div>
    <Partners></Partners>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import Services from '@/components/index/services/services.vue'
import Database from '@/components/index/database/database.vue'
import About from '@/components/index/about/about.vue'
import News from '@/components/index/news/news.vue'
import Literature from '@/components/index/literature/literature.vue'
import Training from '@/components/index/training/training.vue'
import Partners from '@/components/index/partners/partners.vue'
import { setmeta } from '@/assets/js/setmeta'

export default {
  name: 'index',
  components: {
    Headers,
    Footer,
    Database,
    About,
    News,
    Literature,
    Training,
    Partners,
    Services
  },
  mixins: [setmeta],
  data () {
    return {
      swiperOptions: {
        grabCursor: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      bannerlist: [
        {
          banner_img: '/static/index/banner.png'
        },
        {
          banner_img: '/static/index/banner1.png'
        },
        {
          banner_img: '/static/index/banner2.png'
        }
      ]
    }
  },
  methods: {},
  created () {
    this.setMetaConfig({
      web_title: `细胞STR鉴定综合供应商-${this.$env.TITLE}`
    })
  }
}
</script>

<style lang="scss" scoped>
@import './index';
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue